(function() {
  'use strict';

  function initStickyScroll() {
    const containers = document.querySelectorAll('[data-sticky-scroll]');
    
    containers.forEach(container => {
      const items = container.querySelectorAll('[data-sticky-item]');
      if (items.length === 0) return;

      // Store original positions once (before any sticky positioning)
      let originalPositions = null;
      
      function calculateOriginalPositions() {
        // Remove all sticky classes temporarily to get true original positions
        const stickyStates = [];
        items.forEach((item) => {
          stickyStates.push({
            item: item,
            wasSticky: item.classList.contains('is-sticky'),
            stickyTop: item.style.getPropertyValue('--sticky-top')
          });
          item.classList.remove('is-sticky');
          item.style.removeProperty('--sticky-top');
        });
        
        // Force reflow
        void container.offsetHeight;
        
        // Now calculate positions
        const containerRect = container.getBoundingClientRect();
        const containerTop = containerRect.top + window.scrollY;
        
        originalPositions = [];
        items.forEach((item, index) => {
          const itemHeight = item.offsetHeight;
          const itemTop = containerTop + (index * itemHeight);
          const itemBottom = itemTop + itemHeight;
          
          originalPositions.push({ item, index, itemTop, itemBottom, itemHeight });
        });
        
        // Restore sticky states
        stickyStates.forEach(({ item, wasSticky, stickyTop }) => {
          if (wasSticky) {
            item.classList.add('is-sticky');
            if (stickyTop) {
              item.style.setProperty('--sticky-top', stickyTop);
            }
          }
        });
      }

      let ticking = false;

      function updateStickyItems() {
        if (!originalPositions) {
          calculateOriginalPositions();
        }
        
        const scrollY = window.scrollY;
        const viewportHeight = window.innerHeight;
        const baseTop = 100; // Base offset from top
        const itemOffset = 40; // Fixed offset between stacked items (evenwijdig)

        // Get items that are already sticky (they should stay sticky)
        const alreadySticky = [];
        items.forEach((item, index) => {
          if (item.classList.contains('is-sticky')) {
            alreadySticky.push({ item, index });
          }
        });

        // Find new items that should become sticky
        const newStickyItems = [];
        originalPositions.forEach(({ item, index, itemTop }) => {
          // Skip if already sticky
          if (item.classList.contains('is-sticky')) {
            return;
          }
          
          // Item enters viewport when bottom of viewport reaches its original top
          const hasEnteredViewport = scrollY + viewportHeight >= itemTop;

          // Item should become sticky if it has entered viewport
          if (hasEnteredViewport) {
            newStickyItems.push({ item, index });
          }
        });

        // Combine already sticky items with new sticky items
        const allStickyItems = [...alreadySticky, ...newStickyItems];
        
        // Sort by index to maintain correct stacking order
        allStickyItems.sort((a, b) => a.index - b.index);

        // Set sticky positions for all items that should be sticky
        const totalSticky = allStickyItems.length;
        
        // First, remove all sticky styles to recalculate positions
        allStickyItems.forEach((stickyItem) => {
          stickyItem.item.classList.remove('is-sticky');
          stickyItem.item.style.removeProperty('--sticky-top');
          stickyItem.item.style.removeProperty('--sticky-scale');
          stickyItem.item.style.removeProperty('--sticky-translate-y');
        });
        
        // Now apply sticky positions with CONSISTENT spacing for evenwijdig effect
        allStickyItems.forEach((stickyItem, stackIndex) => {
          const itemsBehind = totalSticky - 1 - stackIndex;
          
          // Fixed top position - elk item krijgt exact dezelfde offset
          const topPosition = baseTop + (stackIndex * itemOffset);
          
          // Fixed scale - elk item achter het bovenste krijgt een consistent kleinere scale
          const scale = 1 - (itemsBehind * 0.03); // 3% kleiner per item achter
          
          // Fixed translateY - consistent voor alle items om evenwijdig effect te behouden
          const translateY = 0; // Geen verticale offset, alleen de top position telt
          
          stickyItem.item.classList.add('is-sticky');
          stickyItem.item.style.setProperty('--sticky-top', `${topPosition}px`);
          stickyItem.item.style.setProperty('--sticky-scale', scale);
          stickyItem.item.style.setProperty('--sticky-translate-y', `${translateY}px`);
        });
        
        // Items that are no longer sticky: remove sticky class and reset transforms
        items.forEach((item) => {
          if (!item.classList.contains('is-sticky')) {
            item.classList.remove('is-sticky');
            item.style.removeProperty('--sticky-top');
            item.style.removeProperty('--sticky-scale');
            item.style.removeProperty('--sticky-translate-y');
          }
        });

        ticking = false;
      }

      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(updateStickyItems);
          ticking = true;
        }
      }

      // Initial check
      updateStickyItems();

      // Listen to scroll events
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => {
        originalPositions = null; // Recalculate on resize
        updateStickyItems();
      }, { passive: true });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyScroll);
  } else {
    initStickyScroll();
  }

  // Re-initialize on theme editor changes
  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initStickyScroll);
    document.addEventListener('shopify:section:reorder', initStickyScroll);
  }
})();
